module.exports = __webpack_public_path__ + "static/banner-b57d33830e85952d59d20a2423cb22f8.svg";